import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDownFill = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.415 5c-.891 0-1.337 1.077-.707 1.707l2.586 2.586a1 1 0 0 0 1.414 0l2.586-2.586c.63-.63.183-1.707-.708-1.707H5.415Z" }));
const ForwardRef = forwardRef(SvgChevronDownFill);
export default ForwardRef;
